module.exports = __webpack_public_path__ + "static/media/simon100.744aabcc.jpg";